var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailIconGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.916 4.625C35.618 4.625 37 6.0051 37 7.70895V29.291C37 30.9931 35.6199 32.375 33.916 32.375H3.08395C1.38195 32.375 0 30.9949 0 29.291V7.70895C0 6.00695 1.3801 4.625 3.08395 4.625H33.916ZM13.2608 20.9568L4.1773 29.933H32.5285L23.5431 21.0493L18.5 24.5403L13.2608 20.9568ZM34.484 13.4902L25.6114 19.6248L34.484 28.3864V13.4902ZM2.51785 13.6031V28.0997L11.1869 19.5323L2.51785 13.6031ZM33.8864 7.06885H3.1413C2.97248 7.06093 2.80702 7.11785 2.6788 7.22795C2.62182 7.27897 2.57784 7.34285 2.55049 7.41428C2.52314 7.4857 2.51322 7.56262 2.52155 7.63865V10.6357L18.5 21.5636L34.4914 10.5283V7.76815C34.4932 7.52025 34.4359 7.3408 34.3212 7.22795C34.2643 7.17253 34.1963 7.12973 34.1217 7.10232C34.0471 7.0749 33.9676 7.0635 33.8883 7.06885H33.8864Z",
    fill: "#AA9767"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIconGold);
export default __webpack_public_path__ + "static/media/mail-icon-gold.c90b7be6b64abd39df81b8d447412b14.svg";
export { ForwardRef as ReactComponent };